module.exports = __webpack_public_path__ + "img/dienteAzulClaro.2e245658.svg";